import {
    GET_REPORT_OPTIONS,
    GET_REPORT_OPTIONS_SUCCESS,
    GET_REPORT_OPTIONS_FAILED,
    GET_REPORT,
    GET_REPORT_SUCCESS,
    GET_REPORT_FAILED
} from './actionTypes';

const initialState = {
    error: "",
    loading: false,
    players: undefined,
    campaigns: undefined,
    reports: undefined,
    total: undefined
}

const report = (state = initialState, action) => {
    switch (action.type) {
        case GET_REPORT_OPTIONS:
            state = {
                ...state,
                // loading: true
            }
            break;
        case GET_REPORT_OPTIONS_SUCCESS:
            state = {
                ...state,
                loading: false,
                campaigns: action.payload.campaigns,
                players: action.payload.players
            }
            break;
        case GET_REPORT_OPTIONS_FAILED:
            state = {
                ...state,
                loading: false
            };
            break;

        case GET_REPORT:
            state = {
                ...state,
                loading: true
            }
            break;
        case GET_REPORT_SUCCESS:
            state = {
                ...state,
                loading: false,
                reports: action.payload.reports,
                total: action.payload.total
            }
            break;
        case GET_REPORT_FAILED:
            state = {
                ...state,
                loading: false
            };
            break;


        default:
            state = { ...state };
            break;
    }
    return state;
}

export default report;